import Vue from "vue";
import VueRouter from "vue-router";
import store from "../state/Cliend";

Vue.use(VueRouter);
const routes = [{
        path: "/",
        name: "Report",
        component: () => lazyLoadView(
            import ("../views/Report")),
        beforeEnter: (to, from, next) => {
            next();
        },
        meta: {
            authRequired: true,
            modalView: true,
            title: "Übersicht",
        },
        props: true,
    },
    {
        path: "/mailTemplate",
        name: "MailTemplate",
        component: () => lazyLoadView(
            import ("../views/MailTemplate")),
        beforeEnter: (to, from, next) => {
            next();
        },
    }, {
        path: "/auth",
        name: "auth",
        props: true,
        component: () => lazyLoadView(
            import ("../views/Auth")),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {

                const queries = routeTo.query;
                // If the user is already logged in
                if (
                    Object.keys(queries).length &&
                    queries.key &&
                    queries.accessKey &&
                    queries.secretKey
                ) {
                    next();
                } else {
                    if (store.getters["loggedIn"]) {
                        // Redirect to the home page instead

                        next({
                            name: "Report",
                        });
                    } else {
                        // Continue to the login page
                        next("Login");
                    }
                }
            },
        },
    },
    {
        path: "/login",
        name: "Login",
        component: () => lazyLoadView(
            import ("../views/Login")),
        props: true,
        beforeEnter: (to, from, next) => {
            if (Object.keys(to.query).length && to.query.u && to.query.p) {
                window.localStorage.clear();
                store.dispatch("logOut");
                next({
                    name: "Login",
                    params: {
                        encryptedUsername: to.query.u,
                        encryptedPassword: to.query.p,
                    },
                });
            } else {
                if (store.getters["loggedIn"]) {
                    next({
                        name: "Report",
                    });
                } else {
                    next();
                }
            }
        },
        meta: {
            title: "Anmelden",
        },
    },
    {
        path: "/logout",
        name: "Logout",
        // component: () => lazyLoadView(import("../components/Header/Profil")),
        meta: {
            authRequired: true,
        },
        beforeEnter: (to, from, next) => {
            store.dispatch("logOut");
            window.localStorage.clear();
            next({ name: "Login" });
        }
    }
];

const router = new VueRouter({
    routes
});

router.beforeEach((routeTo, routeFrom, next) => {
    const authRequired = routeTo.matched.some((route) => route.meta.authRequired);
    if (!authRequired) return next();
    if (store.getters["loggedIn"]) {
        return store.dispatch("validate").then((validUser) => {
            if (validUser) {
                next();
            } else {
                redirectToLogin();
            }
        });
    }

    redirectToLogin();


    function redirectToLogin() {
        next({ name: "Login" });
    }
});

router.afterEach((to) => {
    document.title = `${to.meta.title ? to.meta.title + " |" : ""} Daily Report`;
});

function lazyLoadView(AsyncView) {
    const AsyncHandler = () => ({
        component: AsyncView,
        loading: require("../views/Login").default,
        delay: 400,
        error: require("../views/Report").default,
        timeout: 10000,
    });

    return Promise.resolve({
        functional: true,
        render(h, { data, children }) {
            // Transparently pass any props or children
            // to the view component.
            return h(AsyncHandler, data, children);
        },
    });
}

export default router;